import type { FaireProductEntity } from "../../entity_types/product";

export const p_tb2wfderpc: FaireProductEntity = {
  token: "p_tb2wfderpc",
  type: "product",
  name: "Classic Root Beer",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/09a8d2c28ffa00f90538cfcbf457a6577f2a81a978aca8932e6839dd0f847d9b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a0a35528e9f506cddc7aa24c015d143513c61602db6ca4f149bd829f88d233c.png",
    "https://cdn.faire.com/fastly/2d1d7c5210e460931d683f157de81848ea9cd824e36a43ebde8fcaab32634e48.png",
    "https://cdn.faire.com/fastly/ed163f4b6cf9daa1eca798c1b86d240c67e0a3684cfaca7ce6ea294f9fa15b57.png",
    "https://cdn.faire.com/fastly/a5074cd45323f9d8a539ee8f1690763f5fd7e0dafe306b1f4850e2759c5b95ca.png",
  ],
  priceDollars: 28.99,
  description:
    "Our botanically driven Root Beer marries a classic bite with a creamy sweetness with extracts of sweet birch, smooth-vanilla bean and naturally sourced burdock root. We recommend pairing it with your favorite ice-cream.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:07.791Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
